import { getErrorMessage } from "../../shared/utils";
import axios from "axios";
import * as messages from "../../shared/messages";
import * as apiEndPoints from "../../shared/apiPaths";
import * as actionTypes from "./actionTypes";

export const saveFormData = (
  actionId,
  fieldAndValues,
  isSubmit,
  token,
  saveCallback
) => {
  return dispatch => {
    dispatch(saveFormDataRequest());

    const url = window.ENV.API_ROOT + apiEndPoints.SAVE_FORM_DATA;
    const data = {
      actionId: actionId,
      isSubmit: isSubmit,
      fieldAndValues: fieldAndValues
    };

    const config = {
      headers: { Authorization: token.token }
    };

    axios
      .post(url, data, config)
      .then(response => {
        dispatch(saveFormDataSucess(isSubmit));
        saveCallback(isSubmit, true, null);
      })
      .catch(error => {
        let message = getErrorMessage(error);
        dispatch(saveFormDataFailure(message));

        const notificationMessage = (message === messages.Unauthorized ? "Session timed out." : message);
        saveCallback(isSubmit, false, notificationMessage);
      });
  };
};

const saveFormDataSucess = isSubmit => {
  return {
    type: actionTypes.SAVE_FORM_DATA_SUCCESS,
    submitted: isSubmit
  };
};

const saveFormDataRequest = () => {
  return {
    type: actionTypes.SAVE_FORM_DATA_REQUEST
  };
};

const saveFormDataFailure = error => {
  return {
    type: actionTypes.SAVE_FORM_DATA_FAILURE,
    error: error
  };
};
